const host =
  process.env.VUE_APP_API_HOST == 'dinamico'
    ? `${window.location.protocol}//${window.location.host}/`
    : process.env.VUE_APP_API_HOST

const searchApi = `${host}${process.env.VUE_APP_API_PATH_BUSCA}`
const courseApi = `${host}${process.env.VUE_APP_API_PATH_CURSOS}`

export { host, searchApi, courseApi }
